let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("co3FH")).then(() => parcelRequire('hwJUK'));